<div id="lang-btn-toggle" [ngClass]="{ 'selected-language': true, 'is-open': dropdownOpen }" (click)="toggleDropdown()">
  <img [src]="getSelectedFlagUrl()" [alt]="getSelectedLanguageName()">
  <span>{{getSelectedLanguageCode()}}</span>
</div>

@if (dropdownOpen) {
  <ul id="lang-dropdown-list" [ngClass]="{ 'dropdown': true, 'dropdown__is-open': dropdownOpen }">
    @for (lang of languages; track lang) {
      <li [attr.id]="'lang-btn-' + lang.code" (click)="changeLanguage(lang.code)">
        <img [src]="lang.flag" [alt]="lang.name">
        <span>{{ lang.code.slice(-2).toUpperCase() }}</span>
      </li>
    }
  </ul>
}
